export default {
	namespaced: true,
	state: {
    	updatePostEditorStatus:false,
		sections: [],
		activePage: {},
		activePost: {},
		allPostCards: [],
		siteCss:{},
		dashboardSettings: {},
		pageIndex:null,
		design: {},
		importedMedia: {
			media: [],
			nextRequest: ''
		},
		listOfPages: [
			// EXEMPLO DE ESTRUTURA PRO FUTURO
			// {
			//   pageId: "",
			//   pageOrderBy: "",
			//   posts: []
			// }
		],
		loading: true,
		menuSettings: {
			isOpen: false,
			activeOption: 1,
		},
		sidebarSettings: {
			isOpen: false,
		},
		siteData: {},
		comments:[],
		frameVariables: {},
		frameGalleryDefaultType: {
			id: 0,
			hasComments: false,
			hasSidebar: false,
			picture: 'https://uli-pictures.s3.sa-east-1.amazonaws.com/design/maincontent/maincontent_gallery-gallery-default.svg',
			variables: {
				maincontent_gallery: 'gallery-default',
				maincontent_gallery_items: '',
				maincontent_gallery_items_mobile: '',
				maincontent_gallery_items_crop: '',
				maincontent_gallery_padding: '',
			}
		},
		templateOrganismsCombinations: {},
		inDraggable: false,
	},
	getters: {
		getInDraggable: state => {
			return state.inDraggable;
		},
		getSections: state => {
			return state.sections;
		},
		getFrameVariables: state => {
			return state.frameVariables;
		},
		getTemplateOrganismsCombinations: state => {
			return state.templateOrganismsCombinations;
		},
		getTemplateOrgnamismsCombinationsMaincontent: state => {
			return state.templateOrganismsCombinations.maincontent;
		},
		getFrameGalleriesVariables: state => {
			return state.frameVariables.gallery.variables.maincontent_gallery.values;
		},
		getLayoutStyles: state => {
			// define as cores padrão do site (Pega as principais variaveis do css)
			const colors = [
				{
					"id": "invertedTitleColor",
					"value": state.siteCss.invertedTitleColor,
					"name": "Cor do Titulo Invertido do Site"
				},
				{
					"id": "titleColor",
					"value": state.siteCss.titleColor,
					"name": "Cor do Titulo Principal do Site"
				},
				{
					"id": "titleSecondaryColor",
					"value": state.siteCss.titleSecondaryColor,
					"name": "Cor do Titulo Secundário do Site"
				},
				{
					"id": "invertedTextColor",
					"value": state.siteCss.invertedTextColor,
					"name": "Cor do Texto Invertido do Site"
				},
				{
					"id": "textColor",
					"value": state.siteCss.textColor,
					"name": "Cor do Texto Principal do Site"
				},
				{
					"id": "textSecondaryColor",
					"value": state.siteCss.textSecondaryColor,
					"name": "Cor do Texto Secundário do Site"
				},
				{
					"id": "titleCoverColor",
					"value": state.siteCss.titleCoverColor,
					"name": "Cor do Titulo de Capa do Site"
				},
				{
					"id": "primaryColor",
					"value": state.siteCss.primaryColor,
					"name": "Cor Primária do Site"
				},
				{
					"id": "secondaryColor",
					"value": state.siteCss.secondaryColor,
					"name": "Cor Secundária do Site"
				},
				{
					"id": "colorHighlight",
					"value": state.siteCss.colorHighlight,
					"name": "Cor de Destaque do Site"
				},
				{
					"id": "textColorHighlight",
					"value": state.siteCss.textColorHighlight,
					"name": "Cor de Destaque do Texto do Site"
				},
				{
					"id": "backgroundColor",
					"value": state.siteCss.backgroundColor,
					"name": "Cor de Fundo do Site"
				},
				{
					"id": "backgroundSecondaryColor",
					"value": state.siteCss.backgroundSecondaryColor,
					"name": "Cor de Fundo Secundária do Site"
				},
				{
					"id": "backgroundSecondaryColorButton",
					"value": state.siteCss.backgroundSecondaryColorButton,
					"name": "Cor de Fundo Secundária do Botão do Site"
				},
				{
					"id": "backgroundColorButton",
					"value": state.siteCss.backgroundColorButton,
					"name": "Cor de Fundo do Botão do Site"
				},
				{
					"id": "colorTextButton",
					"value": state.siteCss.colorTextButton,
					"name": "Cor do Texto do Botão do Site"
				},
				{
					"id": "fontWeightButton",
					"value": state.siteCss.button_font_weight,
					"name": "Espessura da Fonte do Botão do Site"
				}
			];

			return colors;
		},
		getDefaultFrameColors: state => {
			// define as cores padrão do site (Pega as principais variaveis do css)
			const colors = [
				{
					"value": state.siteCss.invertedTitleColor,
					"name": "Cor do Titulo Invertido do Site"
				},
				{
					"value": state.siteCss.titleColor,
					"name": "Cor do Titulo Principal do Site"
				},
				{
					"value": state.siteCss.titleSecondaryColor,
					"name": "Cor do Titulo Secundário do Site"
				},
				{
					"value": state.siteCss.hightlightColor,
					"name": "Cor de Destaque do Site"
				},
				{
					"value": state.siteCss.textColor,
					"name": "Cor do Texto Principal do Site"
				},
				{
					"value": state.siteCss.textColorHighlight,
					"name": "Cor do Texto de Destaque do Site"
				},
				{
					"value": state.siteCss.textSecondaryColor,
					"name": "Cor do Texto Secundário do Site"
				},
				{
					"value": state.siteCss.titleColor,
					"name": "Cor do Titulo Principal do Site"
				},
				{
					"value": state.siteCss.titleCoverColor,
					"name": "Cor do Titulo de Capa do Site"
				},
				{
					"value": state.siteCss.primaryColor,
					"name": "Cor Primária do Site"
				},
				{
					"value": state.siteCss.secondaryColor,
					"name": "Cor Secundária do Site"
				},
				{
					"value": state.siteCss.colorHighlight,
					"name": "Cor de Destaque do Site"
				},
				{
					"value": state.siteCss.backgroundColor,
					"name": "Cor de Fundo do Site"
				},
				{
					"value": state.siteCss.backgroundColorButton,
					"name": "Cor de Fundo do Botão do Site"
				},
				{
					"value": state.siteCss.backgroundSecondaryColor,
					"name": "Cor de Fundo Secundária do Site"
				},
				{
					"value": state.siteCss.backgroundSecondaryColorButton,
					"name": "Cor de Fundo Secundária do Botão do Site"
				},
			];

			// inicia um set para filtrar as cores repetidas
			let uniqueValues = new Set();

			// inicia um array para armazenar as cores filtradas
			let colorsFiltered = [];

			// filtra as cores repetidas
			colors.map(item => {
				// verifica se a cor já existe no set
				if (!uniqueValues.has(item.value)) {
					// se não existir, adiciona a cor no set e no array de cores filtradas

					// verifica se a cor é válida
					if (item.value !== undefined && item.value !== null && item.value !== 'transparent' && item.value.includes('#')) {
						colorsFiltered.push(item);
						uniqueValues.add(item.value);
					}
				}
			});

			// retorna as cores filtradas
			return colorsFiltered;
		},
		getFrameGalleryDefaultType: state => {
			return state.frameGalleryDefaultType;
		},
		getFrameImageOpacity: state => {
			return state.frameVariables.post.variables.background_image_opacity;
		},
		activePostContent: state => {
			return state.activePost.content;
		},
		allPostActiveImages: state => {
			const filterImages = [...state.activePost.content[0].frameContent.filter(frame => frame.frameType == "image").map(frame => frame.frameContent)];
			const filterThumbnails = [...state.activePost.content[0].frameContent.filter(frame => frame.frameType == "video").map(frame => frame.frameContent.thumbnail)];
			const filterGaleries = [...state.activePost.content[0].frameContent.filter(frame => frame.frameType == "gallery").map(frame => frame.frameContent.items).flat().map(picture => picture.image.url)];
			let allImages = [...filterImages, ...filterThumbnails, ...filterGaleries]
			return allImages.flat(Infinity)
		},
		countImportedMedia: state => {
			return state.importedMedia.media.length;
		},
		getCategories: state => {
			return state.siteData.categories;
		},
		getAllPages: state =>{
			return state.siteData.sections
		},
        getAllPagesAndFilterExternalLink: state =>{
			return state.siteData.sections.filter(section => section.type !== 'external_url')
		},
		getSiteCss: state =>{
			return state.siteData.sections
		},
		getSiteLink: state =>{
			return state.siteData.siteLink
		},
		getComments: state =>{
			return state.comments
		},
		getListPages: state => {
			if (!state.siteData.sections) {
				return []
			}
			return state.siteData.sections.filter(section => section.listPages === 1);
		},
		getNextUrl: state => {
			return state.importedMedia.nextRequest.replace('/api', '');
		},
		loadingStatus: state => {
			return state.loading
		},
		selectedMedias: state => {
			return state.importedMedia.media.filter(media => media.save_media == true)
		},
		getActivePosts: state => {
			return [];
			return state.allPostCards.filter(post => post.category.length > 0)
		},
		getAllPosts: state => {
			return state.allPostCards
		},
		getSiteCss: state => {
			return state.siteCss
		},
		getIsOpenMenu: state =>{
			return state.menuSettings.isOpen
		},
		getActiveOption: state =>{
			return state.menuSettings.activeOption
		},
		getIsOpenSidebarSettings: state =>{
			return state.sidebarSettings.isOpen;
		}
	},
	mutations: {
		updateInDraggable(state, payload) {
			state.inDraggable = payload;
		},
		updateSections(state, payload) {
			state.sections = payload;
		},
		updateFrameVariables(state, payload) {
			state.frameVariables = payload;
		},
		updateTemplateOrganismsCombinations(state, payload) {
			state.templateOrganismsCombinations = payload;
		},
        verifyStatusUpdate(state, payload){
            state.updatePostEditorStatus = payload
        },
		updateSiteData(state, payload) {
			state.siteData = { ...state.siteData, ...payload };
		},
		populateActivePost(state, payload) {
			state.activePost = { ...payload };
			state.loading = false;
		},
		sortPostContent(state, payload) {
			let value = payload
			state.activePost.content[state.pageIndex].frameContent = value;
		},
		sortPageFrame(state, payload) {
			let value = payload
			state.activePost.content = value;
		},
		removeChildFrame(state, { indexChild, indexParent }) {
			const containerFrames = [...state.activePost.content[state.pageIndex].frameContent[indexParent].frameContent];

			containerFrames.splice(indexChild, 1);

			state.activePost.content[state.pageIndex].frameContent[indexParent].frameContent = containerFrames;
		},
		removePostFrame(state, payload) {
			const index = payload;
			const postFrames = [...state.activePost.content[state.pageIndex].frameContent];
			postFrames.splice(index, 1);
			state.activePost.content[state.pageIndex].frameContent = [...postFrames];
		},
		removePageFrame(state, payload) {
			const index = payload;
			const postFrames = [...state.activePost.content];
			postFrames.splice(index, 1);
			state.activePost.content = [...postFrames];
		},
		pushPostFrame(state, payload) {
			if (payload.index !== null) {
				state.activePost.content[state.pageIndex].frameContent.splice(payload.index, 0, payload);
			} else {
				state.activePost.content[state.pageIndex].frameContent.push(payload);
			}
		},
		addChildFrame(state, frame) {
			const position = frame.position
				? frame.position
				: state.activePost.content[state.pageIndex].frameContent[frame.indexParent].frameContent.length;

			state.activePost.content[state.pageIndex].frameContent[frame.indexParent].frameContent.splice(position, 0, frame);
		}, 
		populateImportedMedia(state, payload) {
			state.importedMedia.media = [...state.importedMedia.media, ...payload];
		},
		updateUrlMedia(state, payload) {
			state.importedMedia.nextRequest = payload;
		},
		toggleMedia(state, payload) {
			let indexToToggle = state.importedMedia.media.findIndex(media => media == payload);
			if (indexToToggle >= 0) {
				state.importedMedia.media[indexToToggle].save_media = !state.importedMedia.media[indexToToggle].save_media
			}
		},
		resetAllSaveMedia(state) {
			state.importedMedia.media.forEach(media => {
				if (media.save_media == true) {
					media.save_media = false;
				}
			});
		},
		updatePostThumbnail(state, payload) {
			state.activePost.thumbnail = payload;
		},
		updatePostSettings(state, payload) {
			state.activePost.categories = payload.categories;
			state.activePost.dates = payload.dates;
			state.activePost.isAtHome = payload.isAtHome;
			state.activePost.location = payload.location;
			state.activePost.pages = payload.pages;
			state.activePost.sketch = payload.sketch;
			state.activePost.summary = payload.summary;
			state.activePost.tags = payload.tags;
			state.activePost.title = payload.title;
			state.activePost.visible = payload.visible;
		},
		updatePageIndex(state, payload) {
			state.pageIndex = payload
		},
		updateFrame(state, payload) {
			if(payload.frame.items){
				state.activePost.content[state.pageIndex].frameContent[payload.index].frameContent = payload.frame;
			}
			else{
				state.activePost.content[state.pageIndex].frameContent[payload.index] = payload.frame;
			}
		},
		updateChildFrame(state, payload) {
			state.activePost.content[state.pageIndex].frameContent[payload.indexParent].frameContent[payload.indexChild] = payload.frame;
		},
		updatePageFrame(state, payload) {
			state.activePost.content[state.pageIndex] = payload.frame;
		},
		toggleLoading(state, payload) {
			state.loading = payload
		},
		clearActivePost(state) {
			state.activePost = {}
		},
		addCategory(state, payload) {
			state.siteData.categories.push(payload);
		},
		removeCategory(state, payload) {
			state.siteData.categories.splice(payload, 1)
		},
		removePostCategory(state, payload) {
			state.activePost.categories.splice(payload, 1)
		},
		updateCategories(state, payload) {
			state.siteData.categories = payload;
		},
		addSections(state, payload) {
			state.siteData.sections.push(payload);
			localStorage.setItem("siteData", JSON.stringify(state.siteData));
		},
		updatePostCards(state, payload) {
			state.allPostCards = payload;
		},
		updateSiteCss(state, payload) {
			state.siteCss = payload;
		},
		toggleMenu(state){
			state.menuSettings.isOpen = !state.menuSettings.isOpen

			// VOLTANDO A SIDEBAR PARA A OPÇÃO 1 (NENHUMA NAVEGAÇAO ATIVA) QUANDO FECHADA
			if (!state.menuSettings.isOpen) {
				state.menuSettings.activeOption = 1
			}
		},
		toggleSidebarSettings(state){
			state.sidebarSettings.isOpen = !state.sidebarSettings.isOpen
		},
		updateMenuOption(state, payload){
			state.menuSettings.activeOption = payload
		},
		updateSiteLink(state, payload){
			state.siteData.siteLink = payload
		},
		updateComments(state, payload){
			state.comments = payload
		},
	},
	actions: {
		UPDATE_IN_DRAGGABLE(context, inDraggable) {
			this.commit("dashboardModule/updateInDraggable", inDraggable);
		},
		UPDATE_SECTIONS(context, sections) {
			this.commit("dashboardModule/updateSections", sections);
		},
		UPDATE_FRAME_VARIABLES(context, variables) {
			this.commit("dashboardModule/updateFrameVariables", variables);
		},
		UPDATE_TEMPLATE_ORGANISMS_COMBINATIONS(context, combinations) {
			this.commit("dashboardModule/updateTemplateOrganismsCombinations", combinations);
		},
		TOGGLE_MENU(){
			this.commit("dashboardModule/toggleMenu");
		},
		TOGGLE_SIDEBAR_SETTINGS(){
			this.commit("dashboardModule/toggleSidebarSettings");
		},
		UPDATE_MENU_OPTION(context, [index]) {
			this.commit("dashboardModule/updateMenuOption", index);
		},
		getPostData(context, [postData]) {
			// if (postData.dates.published_at == null) {
			// 	postData.dates.published_at = postData.dates.created_at
			// }
			this.commit("dashboardModule/populateActivePost", postData);
		},
		pushNewPostFrame(context, [newFrame]) {
			this.commit("dashboardModule/pushPostFrame", newFrame);
		},
		addChildFrame(context, [newChildFrame]) {
			this.commit("dashboardModule/addChildFrame", newChildFrame);
		},
		removeChildFrame(context, [indexChild, indexParent]) {
			this.commit("dashboardModule/removeChildFrame", {indexChild: indexChild, indexParent: indexParent});
		},
		removePostFrame(context, [index]) {
			this.commit("dashboardModule/removePostFrame", index);
		},
		removePageFrame(context, [index]) {
			this.commit("dashboardModule/removePageFrame", index);
		},
		setSiteLink(context, [index]) {
			this.commit("dashboardModule/updateSiteLink", index);
		},
		setComments(context, [index]) {
			this.commit("dashboardModule/updateComments", index);
		},
		populateImportedMedia(context, [media, next]) {
			this.commit("dashboardModule/populateImportedMedia", media);
			this.commit("dashboardModule/updateUrlMedia", next);
		},
		toggleMedia(context, [media]) {
			this.commit("dashboardModule/toggleMedia", media);
		},
		resetAllSaveMedia() {
			this.commit("dashboardModule/resetAllSaveMedia");
		},
		UPDATE_POST_THUMBNAIL(context, [thumbnail]) {
			this.commit("dashboardModule/updatePostThumbnail", thumbnail);
		},
		TOGGLEPAGE(context, [page]) {
			this.commit("dashboardModule/togglePage", page);
		},
		UPDATE_POST_SETTINGS(context, [settingsData]) {
			this.commit("dashboardModule/updatePostSettings", settingsData);
		},
		TOGGLE_LOADING(context, [value]) {
			this.commit("dashboardModule/toggleLoading", value)
		},
		CLEAR_ACTIVE_POST() {
			this.commit("dashboardModule/clearActivePost")
		},
		ADD_CATEGORY(context, [category]) {
			this.commit("dashboardModule/addCategory", category)
		},
		REMOVE_CATEGORY({ context, state }, [category]) {
			const indexToRemove = state.siteData.categories.findIndex(element => element == category)
			this.commit("dashboardModule/removeCategory", indexToRemove)
		},
		REMOVE_POST_CATEGORY({ context, state }, [category]) {
			const indexToRemove = state.activePost.categories.findIndex(element => element == category)
			this.commit("dashboardModule/removePostCategory", indexToRemove)
		},
		UPDATE_CATEGORIES(context, [category]) {
			this.commit("dashboardModule/updateCategories", category)
		},
		ADD_SECTIONS(context, [sections]) {
			this.commit("dashboardModule/addSections", sections)
		},
		UPDATE_FRAME(context, [pageIndex, frameIndex, postContent]) {
			const frameData = {
				index: frameIndex,
				frame: postContent
			}
			this.commit("dashboardModule/updatePageIndex", pageIndex)
			this.commit("dashboardModule/updateFrame", frameData)
		},
		UPDATE_CHILD(context, [pageIndex, indexParent, indexChild, postContent]) {
			const frameData = {
				indexParent: indexParent,
				indexChild: indexChild,
				frame: postContent
			}
			this.commit("dashboardModule/updatePageIndex", pageIndex)
			this.commit("dashboardModule/updateChildFrame", frameData)
		},
		UPDATE_PAGE_FRAME(context, [postContent]) {
			const frameData = {
				frame: postContent
			}
			this.commit("dashboardModule/updatePageFrame", frameData)
		},
		POPULATEPOSTCARDS(context, [posts]) {
			this.commit("dashboardModule/updatePostCards", posts);
		},
		POPULATESITECSS(context, siteCss) {
			this.commit("dashboardModule/updateSiteCss", siteCss);
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModule.js